import { useRef, useEffect } from 'react';
import {
  headingsPlugin,
  linkPlugin,
  listsPlugin,
  MDXEditor,
  MDXEditorMethods,
} from '@mdxeditor/editor';
import { formatDate, IconDownload, IconEdit, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import { ChatMessageType } from './types';

import cn from './messages.module.css';

const ChatMessage = ({
  messageName,
  item,
  setMessageIsEdit,
  setSelectedForEditMessage,
  selectedForEditMessage,
  editMessageMarkdown,
  markdownRef,
  getFile,
  downloadInProgress,
  isFetching,
  selectedDocumentId,
  dateString,
}: ChatMessageType) => {
  const ref = useRef<MDXEditorMethods | null>(null);

  const { employee } = useAppSelector((state) => state.messages.general);

  useEffect(() => {
    if (ref && item) {
      ref?.current?.setMarkdown(item.content as string);
    }
  }, [ref, item]);

  return (
    <>
      {messageName && (
        <div
          className={`${cn.newMessageContentUser} ${
            cn.newMessageContentUserWithMargin
          } ${
            item.employeeId || item.userId === employee?.id
              ? cn.messageBlockRight
              : ''
          }`}
        >
          {messageName}
        </div>
      )}
      <div
        className={`${cn.messageBlock} ${
          item.employeeId || item.userId === employee?.id
            ? cn.messageBlockRight
            : ''
        }`}
        key={item.id}
      >
        {setMessageIsEdit &&
          setSelectedForEditMessage &&
          selectedForEditMessage?.id !== item.id &&
          (item.userId === employee?.id ||
            item.employeeId === employee?.id) && (
            <div className={cn.editMessageButtonWrapper}>
              <button
                type="button"
                className={cn.editMessageButton}
                onClick={() => {
                  setMessageIsEdit(true);
                  setSelectedForEditMessage(item);

                  editMessageMarkdown?.current?.setMarkdown(
                    item.content as string,
                  );

                  markdownRef?.current?.setMarkdown(item.content as string);
                }}
              >
                <IconEdit width={18} height={18} />
              </button>
            </div>
          )}
        <span className={cn.messageBlockContent}>
          <div className={cn.messageContent}>
            {item.document && (
              <div
                className={`${cn.messageAttachment} ${
                  item.content ? cn.messageAttachmentMargin : ''
                }`}
              >
                <button
                  type="button"
                  className={cn.messageAttachmentLink}
                  aria-label="Dwnload link"
                  onClick={() =>
                    getFile(
                      item?.documentId as string,
                      item.document?.name as string,
                    )
                  }
                >
                  {(downloadInProgress || isFetching) &&
                  selectedDocumentId === item.documentId ? (
                    <IconLoader width={20} height={20} />
                  ) : (
                    <IconDownload />
                  )}
                </button>
                <div className={cn.messageAttachmentName}>
                  {item.document.name}
                </div>
              </div>
            )}
            {item.content && (
              <MDXEditor
                ref={ref}
                className={cn.messageMarkdown}
                markdown={item.content || ''}
                readOnly
                plugins={[linkPlugin(), listsPlugin(), headingsPlugin()]}
              />
            )}
          </div>
          <div className={cn.messageDate}>{dateString}</div>
        </span>
        {item?.edited && (
          <div className={cn.messageEdited}>
            <IconEdit className={cn.messageEditedIcon} width={13} height={13} />
            {`edited ${
              item?.updatedAt
                ? `at ${new Date(item?.updatedAt)
                    .getHours()
                    .toString()
                    .padStart(2, '0')}:${new Date(item?.updatedAt)
                    .getMinutes()
                    .toString()
                    .padStart(2, '0')} (${formatDate(item?.updatedAt)})`
                : ''
            }`}
          </div>
        )}
      </div>
    </>
  );
};

export default ChatMessage;
